import React from 'react';
import { getSaveIndicator } from './notebookPageHelpers';

const DOT_CLASS = {
  ok: 'bg-[#10B981]',
  pending: 'bg-[#F59E0B] motion-safe:animate-pulse',
  offline: 'bg-[#9CA3AF]',
  error: 'bg-[#EF4444]',
};

/**
 * Compact save state (dot + word) for the notebook sidebar header. It stays a
 * button so a click still forces a save when there are pending changes.
 */
export default function SaveStatusIndicator({
  syncStatus,
  syncLabel,
  hasPendingUnsaved,
  manualSaveInFlight,
  onSaveNow,
}) {
  const { label, tone } = getSaveIndicator(syncStatus, manualSaveInFlight);
  const action = manualSaveInFlight
    ? 'Saving… please wait'
    : (hasPendingUnsaved ? 'Save changes now' : 'Force save check now');
  const detail = syncLabel && syncLabel !== label ? `${syncLabel}. ` : '';

  return (
    <button
      type="button"
      onClick={onSaveNow}
      disabled={manualSaveInFlight}
      title={`${detail}${action}`}
      aria-label={`Save status: ${label}. ${action}`}
      data-save-tone={tone}
      className={`inline-flex min-w-0 items-center gap-1.5 rounded px-1.5 py-0.5 text-xs tabular-nums transition-colors disabled:cursor-wait ${
        tone === 'error'
          ? 'text-[#DC2626] dark:text-[#F87171]'
          : 'text-[#6B7280] dark:text-[#9CA3AF]'
      } ${hasPendingUnsaved ? 'hover:bg-[#F3F4F6] hover:text-[#111827] dark:hover:bg-[#374151] dark:hover:text-[#F9FAFB]' : 'hover:text-[#111827] dark:hover:text-[#F9FAFB]'}`}
    >
      <span aria-hidden="true" className={`h-1.5 w-1.5 shrink-0 rounded-full ${DOT_CLASS[tone]}`} />
      <span className="truncate">{label}</span>
    </button>
  );
}
